import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    // 用户信息
    userInfo: {},

    /**
     * 刷新列表
     * 监听到对应值有改变就会重新请求
     * */

    Refresh_Organize: 0, //刷新组织架构的组织树
    Refresh_UserList: 0, //刷新组织架构成员列表
    Refresh_User_Msg: 0, //刷新组织架构成员信息

    /**
     * 抽屉
     * */

    Drawer_UserManagement_Edit: false, //用户管理右侧编辑
    Drawer_useUnitManagement_Edit: false, //使用单位右侧编辑
    Drawer_Department_Edit: false, //修改部门信息抽屉
    Drawer_Member_Modify: false, //修改成员抽屉
    Drawer_Department_Add: false, //新增子部门

    /**
     * 模态框
     * */

    Dialog_Change_Dept: null, // 修改了成员的所属部门
    Dialog_Adjust_Members: false, //调整成员部门
    Dialog_Division_ChangeUpper: false, //修改上级部门模态框
    Dialog_Admin_Handover: false, //移交主管理员
    Dialog_Change_Phone: false, //修改电话号码

    /**
     * 其他
     * */

    EditDepartmentInformation: null, //编辑部门信息保存的部门ID
    LoginstatusbyPhone: 1, //手机号登录状态
  },

  mutations: {
    SET_User_Info (state, e) {
      state.userInfo = e
    },

    /**
     * 新增子部门
     * */

    SET_Drawer_Department_Add(state, e) {
      state.Drawer_Department_Add = e
    },

    /**
     * 刷新组织架构的组织树
     * */

    SET_Refresh_Organize(state) {
      state.Refresh_Organize++
    },

    /**
     * 刷新组织架构成员列表
     * */

    SET_Refresh_UserList(state) {
      state.Refresh_UserList++
    },

    /**
     * 刷新组织架构成员信息
     * */

    SET_Refresh_User_Msg(state) {
      state.Refresh_User_Msg++
    },
    // 修改了成员的所属部门
    SET_Dialog_Change_Dept(state, e) {
      state.Dialog_Change_Dept = e
    },
    /**
     * 修改电话号码流程
     * */

    SET_Dialog_Change_Phone(state, e) {
      state.Dialog_Change_Phone = e
    },

    /**
     * 移交主管理员模态框打开关闭
     * */

    SET_Dialog_Admin_Handover(state, e) {
      state.Dialog_Admin_Handover = e
    },


    /**
     * 调整成员部门模态框打开关闭
     * */

    SET_Dialog_Adjust_Members(state, e) {
      state.Dialog_Adjust_Members = e
    },

    /**
     * 修改成员抽屉打开关闭
     * */

    SET_Drawer_Member_Modify(state, e) {
      state.Drawer_Member_Modify = e
    },

    /**
     * 修改上级部门模态框打开关闭
     * */

    SET_Dialog_Division_ChangeUpper(state, e) {
      state.Dialog_Division_ChangeUpper = e
    },

    /**
     * 修改部门信息右侧编辑打开关闭
     * */

    SET_Drawer_Department_Edit(state, e) {
      state.Drawer_Department_Edit = e
    },

    /**
     * 用户管理右侧编辑打开关闭
     * */

    SET_Drawer_UserManagement_Edit(state, e) {
      state.Drawer_UserManagement_Edit = e
    },

    /**
     * 使用单位管理右侧编辑打开关闭
     * */

    SET_Drawer_UseUnitManagement_Edit(state, e) {
      console.log(e, '使用单位管理右侧编辑打开关闭')
      state.Drawer_UseUnitManagement_Edit = e
    },

    /**
     * 编辑部门信息保存的部门ID
     * */

    SET_EditDepartmentInformation(state, e) {
      state.EditDepartmentInformation = e
    },

    /**
     * 手机号登录状态
     * */

    SET_LoginstatusbyPhone(state, e) {
      state.LoginstatusbyPhone = e
    },
  },
  actions: {},
  modules: {}
})